import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { any, string, object } from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import loadable from '@loadable/component';
import { AuthContext } from '../../../Contexts';
const AuthenticateModal = loadable(() =>
  import('../../HomeDeliveryNew/AuthenticateModal')
);
const SignupModal = loadable(() => import('../../common/SignupModal.jsx'));
const SignInModal = loadable(() =>
  import('../../HomeDeliveryNew/AuthenticateModal/signInModal')
);
const FlashModal = loadable(() => import('../../HomeDeliveryNew/FlashModal'));
const GeniusR = ({
  drugName,
  mailOrderPricings,
  selectedDisplayQuantity,
  drugData,
  lowestPrice,
  lowestPricePharmacyName,
  isMobileDevice
}) => {
  const [isAuthModal, setIsAuthModal] = useState(false);
  const [isSignUpModal, setIsSignUpModal] = useState(false);
  const [isSignInModal, setIsSignInModal] = useState(false);
  const [isFlashModal, setIsFlashModal] = useState(false);
  const [userStatus, setUserStatus] = useState('logged-in');
  const [isGeniusrxTooltipClick, setIsGeniusrxTooltipClick] = useState(false);
  //Todo - check is weh have to keep it or use store
  const userData = useContext(AuthContext)?.userData;
  const isLoggedIn = userData?.isLoggedIn;
  const prices = mailOrderPricings.Prices;
  const pharmacy = mailOrderPricings.Pharmacy;
  const currentPrice =
    !isLoggedIn && prices[0].LoyaltyApplicable
      ? prices[0].LoyaltyPrice
      : prices[0].Price;

  const { t, i18n } = useTranslation();

  let eventObj = {
    drugName: drugData.name,
    seoName: drugData.seoName,
    NDC: drugData.ndc,
    GPI: drugData.gpi,
    drugBrand: drugData?.drugType
      ? drugData?.drugType
      : drugData.isGeneric
      ? 'generic'
      : 'brand',
    drugForm: drugData.form,
    drugDosage: drugData.dosage,
    drugQuantity: drugData.quantity,
    drugQuantityUnit: 'count',
    lowestPrice: lowestPrice,
    lowestPricePharmacyName: lowestPricePharmacyName,
    pharmacyPrice: currentPrice,
    priceUsualAndCustomary: prices[0].UsualAndCustomary,
    singlecarePrice: prices[0].Price,
    geniusRxLink: mailOrderPricings.redirectUrl,
    loyaltyApplicable: prices[0].LoyaltyApplicable,
    loyaltyBonusSavings: prices[0].LoyaltyBonusSavings,
    loyaltyExcluded: prices[0].LoyaltyExcluded,
    loyaltyPrice: prices[0].LoyaltyPrice
  };

  const toggleSignUp = () => {
    _.triggerGTMVirtualPageViewEvent({
      ...eventObj,
      event: 'geniusRxSignUpClick',
      clickText: 'Sign up'
    });
    setIsAuthModal(false);
    setIsSignUpModal(true);
  };

  const redirectUrl = url => {
    return _.isEmpty(url)
      ? ''
      : url.replace(
          new RegExp(
            '{{DisplayQuantity}}'.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'),
            'g'
          ),
          selectedDisplayQuantity
        );
  };

  const onHomeDeliveryClick = () => {
    _.triggerGTMVirtualPageViewEvent({
      ...eventObj,
      event: 'geniusRxCtaClick',
      clickText: 'Home delivery',
      geniusRxPrice: currentPrice
    });
    if (!isLoggedIn) {
      setIsAuthModal(true);
    } else {
      _.triggerGTMVirtualPageViewEvent({
        ...eventObj,
        event: 'geniusRxRedirectLoggedIn',
        formId: userStatus
      });
      window.open(redirectUrl(mailOrderPricings.redirectUrl), '_self');
    }
  };

  const openSignIn = () => {
    _.triggerGTMVirtualPageViewEvent({
      ...eventObj,
      event: 'geniusRxSignInClick',
      clickText: 'Sign in'
    });
    setIsAuthModal(false);
    setIsSignInModal(true);
  };

  const numberWithCommas = (price = '') => {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const hideSignInOpenFlashModal = () => {
    _.triggerGTMVirtualPageViewEvent({
      ...eventObj,
      event: 'geniusRxSignInSuccess',
      formId: 'sign in'
    });
    setIsSignInModal(false);
    setUserStatus('sign-in');
    openFlashModal();
  };

  const openFlashModal = () => {
    let evenType = _.isEqual(userStatus, 'sign-in')
      ? 'geniusRxRedirectSignIn'
      : 'geniusRxRedirectSignup';
    _.triggerGTMVirtualPageViewEvent({
      ...eventObj,
      event: evenType,
      formId: userStatus
    });
    window.open(redirectUrl(mailOrderPricings.redirectUrl), '_self');
  };

  const hideSignUpOpenFlashModal = () => {
    _.triggerGTMVirtualPageViewEvent({
      ...eventObj,
      event: 'geniusRxSignUpSuccess',
      formId: 'sign up'
    });
    setIsSignUpModal(false);
    setUserStatus('sign-up');
    openFlashModal();
  };

  useEffect(() => {
    document.body.style.overflow = isAuthModal ? 'hidden' : 'auto';
  }, [isAuthModal]);

  return (
    <div className="GeniusRContent">
      <div className="homeDeliveryLabel">Home Delivery</div>
      <div className="pharmacy-item__5off pharmacy-item genusSection">
        <div className="pharmacy-item__details loyaltyItem">
          <div className="pharmacy-item__meta">
            <div className="pharmacy-item__location">
              {!_.isEmpty(pharmacy.LogoUrl) ? (
                <div className="pharmcy-item-image">
                  <img
                    data-name={_.lowerCase(pharmacy.Name)}
                    alt={_.getPharmacyALTName(
                      `${drugName} coupon at ${pharmacy.Name}`
                    )}
                    srcSet={pharmacy.LogoUrl}
                    src={pharmacy.LogoUrl}
                    className="pharmacy-item__name"
                  />
                  <div>
                    <span className="infoTooltio">
                      <b
                        tabIndex="0"
                        role="tooltip"
                        onKeyDown={e => {
                          if (e.key === 'Enter') {
                            setIsGeniusrxTooltipClick(!isGeniusrxTooltipClick);
                          }
                        }}
                        aria-describedby="infoTooltip"
                        aria-label={t('Open pricing info')}
                      >
                        {' '}
                        {t('i')}
                      </b>
                    </span>

                    <div
                      className={`showTooltip ${
                        isGeniusrxTooltipClick ? 'showTooltipOnClick' : ''
                      }`}
                    >
                      <span id="infoTooltip">{t('genius_tooltip')}</span>
                    </div>
                  </div>
                </div>
              ) : (
                <h4 className="pharmacy-item__name">{pharmacy.Name}</h4>
              )}
            </div>
            <div className="PriceSection">
              <div className="pharmacy-item__price SignUpbonusPrice">
                <span className="pharmacy-item__price">
                  <b> $ </b>
                  {Number(currentPrice) > 1000
                    ? numberWithCommas(_.round(Number(currentPrice)))
                    : Number(currentPrice).toFixed(2)}
                </span>
                {_.isEqual(isMobileDevice, false) && (
                  <div className="desktop-only">
                    {isLoggedIn &&
                      prices[0].LoyaltyApplicable &&
                      prices[0].LoyaltyBonusSavings > 0 && (
                        <div className="bonusSavingsDetails">
                          <div className="BonusSavings">
                            {i18n.language === 'es' && (
                              <span>Se aplicaron</span>
                            )}
                            <span> -${prices[0].LoyaltyBonusSavings} </span>
                            <label> {t('bonus savings applied')} </label>
                          </div>
                        </div>
                      )}
                  </div>
                )}
              </div>
              <span className="LabelShipping">
                <span>{t('Free shipping')}</span>
              </span>
            </div>
          </div>
          {_.isEqual(isMobileDevice, true) && isLoggedIn && (
            <div className="PriceSection mobile-only">
              {prices[0].LoyaltyApplicable &&
                prices[0].LoyaltyBonusSavings > 0 && (
                  <div className="bonusSavingsDetails">
                    <div className="BonusSavings">
                      {i18n.language === 'es' && <span>Se aplicaron</span>}
                      <span> -${prices[0].LoyaltyBonusSavings} </span>
                      <label> {t('bonus savings applied')} </label>
                    </div>
                  </div>
                )}
            </div>
          )}
          <div className="d-flex">
            <div className="pharmacy-item__cta">
              <button
                id="geniusrx-homedelivery-new"
                className="sc-btn-pink rx-get-this-price geniusrx-homedelivery-new geniusrx-homedelivery-cta showCta themeFocus"
                onClick={() => onHomeDeliveryClick()}
              >
                <span>
                  <LazyLoadImage
                    src="/content/images/icons/truck.png"
                    height="22px"
                    width="22px"
                    alt=""
                  />
                </span>
                {_.isEqual(isMobileDevice, false) && (
                  <span className="desktop-only">{t('Home delivery')}</span>
                )}
                {_.isEqual(isMobileDevice, true) && (
                  <span className="mobile-only">{t('Get home delivery')}</span>
                )}
                <span className="finalDrugPrice">
                  <span>$</span> {currentPrice}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      {isAuthModal && (
        <AuthenticateModal
          hideAuthenticateModal={() => setIsAuthModal(false)}
          openSignUpModal={() => toggleSignUp()}
          openSignIn={() => openSignIn()}
          redirectUri={mailOrderPricings.redirectUrl}
          quantity={selectedDisplayQuantity}
          isFromHomeDelivery={true}
        />
      )}
      {isSignUpModal && (
        <div className="mainModal afterSignupmodal">
          <div
            className="transparentBg"
            onClick={() => setIsSignUpModal(false)}
          ></div>
          <div className="signUpModal">
            <SignupModal
              isFromHomeDelivery={true}
              closeSignupModal={() => setIsSignUpModal(false)}
              hideSignUpOpenFlashModal={() => hideSignUpOpenFlashModal()}
            />
          </div>
        </div>
      )}
      {isSignInModal && (
        <SignInModal
          redirectUri={mailOrderPricings.redirectUrl}
          hideSignInModal={() => setIsSignInModal(false)}
          hideSignInOpenFlashModal={() => hideSignInOpenFlashModal()}
        />
      )}
      {isFlashModal && (
        <FlashModal
          closeFlashModal={() => setIsFlashModal(false)}
          userStatus={userStatus}
        />
      )}
    </div>
  );
};

GeniusR.propTypes = {
  mailOrderPricings: object,
  selectedDisplayQuantity: string,
  drugData: any,
  lowestPrice: string,
  lowestPricePharmacyName: string
};

GeniusR.defaultProps = {
  mailOrderPricings: {
    Prices: {
      LoyaltyApplicable: false,
      LoyaltyPrice: 0,
      Price: 0,
      LoyaltyBonusSavings: 0
    },
    Pharmacy: {
      Name: 'Mailmyprescriptionscom',
      LogoUrl: ''
    },
    redirectUrl: ''
  },
  selectedDisplayQuantity: '',
  drugData: {},
  lowestPrice: '',
  lowestPricePharmacyName: ''
};

export default React.memo(GeniusR);
